import { useCallback } from 'react';
import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';
import { TriggerSegmentationRules } from 'sections/onsite-campaigns/types';

export const useSaveTriggerSegmentation = () => {
  const { dispatch } = useCampaignEditorContext();
  return useCallback(
    (segmentation: TriggerSegmentationRules) => {
      dispatch({
        type: 'SAVE_TRIGGER_SEGMENTATION',
        payload: {
          segmentation,
        },
      });
    },
    [dispatch],
  );
};
